<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card
      v-else-if="!this.loading && !this.errormessage"
      class="mt-3"
    >
      <div v-if="rowData.length > 0">
        <div class="d-none d-md-block">
          <el-table
            :data="rowData"
            header-row-class-name="text-danger"
            size="small"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            @cell-click="onCellClick"
          >
            <el-table-column
              label="Name"
              sortable
              property="FullName"
              label-class-name="text-danger"
              class-name="text-primary pointer column50"
            />
            <el-table-column
              label-class-name="text-danger"
              class-name="text-primary pointer column50"
              sortable
              label="Email"
            >
              <template slot-scope="props">
                <a :href="'mailto:' + props.row.EmailAddress">{{ props.row.EmailAddress }}</a>
              </template>
            </el-table-column>
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="City"
              property="City"
              width="110px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="State"
              property="State"
              width="60px"
            />
            <el-table-column
              label="Phone"
              property="PhoneNumber"
              width="100px"
              class-name="column50"
            />
          </el-table>
        </div>
        <div class="d-block d-md-none">
          <el-table
            :data="rowData"
            header-row-class-name="text-danger"
            size="small"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            @cell-click="onCellClick"
          >
            <el-table-column
              label="Name"
              sortable
              property="FullName"
              label-class-name="text-danger"
              class-name="text-primary pointer column50"
            />
            <el-table-column
              label="Phone"
              property="PhoneNumber"
              width="100px"
              class-name="column50"
            />
          </el-table>
        </div>
      </div>
      <div
        v-else
        class="text-center"
      >
        <p class="card-category">
          There are no {{ emptyDataSetLabel }}s signed up for this course.
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import scouterApi from '@/services/api/scouter'
import oops from '@/components/_main/oops.vue'

export default {
  name: 'ScouterList',
  props: {
    scouterType: {
      type: String,
      default: null
    }
  },
  components: {
    oops
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      rowData: null,
      loading: true,
      errormessage: null,
      tempHolder: null
    }
  },
  computed: {
    emptyDataSetLabel: function () {
      if (this.scouterType === 'participant') {
        return 'participant'
      } else if (this.scouterType === 'staff') {
        return 'staff member'
      } else {
        return ''
      }
    }
  },
  mounted () {
    scouterApi
      .list(this.$root.courseKey, this.scouterType)
      .then(x => {
        this.rowData = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    onCellClick: function (row, column, cell, event) {
      this.tempHolder = { c: cell, r: row, co: column, e: event }
      if (column.label === 'Name') {
        let path = ''
        if (this.scouterType === 'participant') {
          path = '/staff/participant?s=' + row.ScouterKey + '&r=list'
        } else if (this.scouterType === 'staff') {
          path = '/staff/participant?s=' + row.ScouterKey + '&r=staff'
        }
        this.$router.push(path)
      }
    }
  }
}
</script>
<style lang="css" scoped>
.pointer {
  cursor: pointer;
}
@media (max-width: 680px) {
  table tr .column50 .cell {
    width: 200px;
  }
  table thead tr .column50 .cell {
    width: 100px;
  }
}
</style>
